import {
  Grid,
  Paper,
  Text,
  Title,
  Group,
  Button,
  SimpleGrid,
  Select,
  Radio,
  Checkbox,
  Divider,
  Tooltip,
  Flex,
  Popover,
  TextInput,
  Tabs,
  Loader,
  Card,
  ScrollArea,
} from "@mantine/core";
import {
  IconCircleCheckFilled,
  IconUpload,
  IconInfoCircle,
  IconBackground,
  IconContainer,
  IconArrowLeft,
} from "@tabler/icons-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Dropzone, MIME_TYPES, FileWithPath } from "@mantine/dropzone";
import { BannerTheme } from "./BannerTheme";
import { ButtonTheme } from "./ButtonTheme";
import { ConsentConfig } from "../../../Models/consentConfig";
import './consent.css';
import { ConsentService } from "../../../services/consentService";
import { ConfigContext } from "../../../Context/configContext";
import { regulations, layouts, finalConsentConfig, themesConfig, defaultBannerContent } from "../../../utils/utils";
import { useDisclosure } from "@mantine/hooks";
import ReactQuill from 'react-quill';
import { PricingService } from "@/services/pricingService";
import colorgradient from '../../../images/colorgradient.png';
import { IconSettings } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { useTranslation } from 'react-i18next';

declare var Cookiex: {
  new (): {
      init(theme: { domainId: string; domainName: string }): void;
  };
};

function BannerConfiguration(props:any): JSX.Element {
  const { t } = useTranslation();
  const { config } = useContext(ConfigContext);
  const [layoutType, setLayoutType] = useState(props.consentConfigData?.theme?.layout || "Box");
  const [themeType, setThemeType] = useState(props.consentConfigData?.theme?.type || "Light");
  const [buttonStyle, setButtonStyle] = useState(props.consentConfigData?.theme?.theme?.buttonStyle || "Mixed");
  const [bannerValue, setBannerValue] = useState(props.consentConfigData?.theme?.alignment || "leftBottomPopUp");
  const [bannerContent, setBannerContent] = useState(props.consentConfigData?.theme?.bannerContent || defaultBannerContent);
  const [files, setFiles] = useState<FileWithPath[]>([]);
  const [tempFile, setTempFile] = useState<FileWithPath[]>([]);
  const [isLogoShown, SetLogoShown] = useState(true);
  const [language, setLanguage] = useState<any>(null);
  const [languageOptions, setLanguageOptions] = useState<any[]>([]);
  const [customThemeStyle, setCustomThemeStyle] = useState<any>(props.consentConfigData?.theme || finalConsentConfig);
  const [consentConfig, setConsentConfig] = useState<ConsentConfig>(props.consentConfigData?.theme || finalConsentConfig);
  const initialRef = useRef(false);
  const [regulation, setRegulation] = useState<any>(props.consentConfigData?.theme?.regulation || regulations[0]);
  const [openedContent, { open: openContent, close: closeContent }] = useDisclosure(false); // For content drawer
  const [activeSection, setActiveSection] = useState("");
  const [data, setData] = useState<any>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [hovering, setHovering] = useState(false);

  const consentService = new ConsentService(config!);
  const pricingService = new PricingService(config!);

  useEffect(() => {
       if(props.consentConfigData?.theme) {
           setCustomThemeStyle(props?.consentConfigData?.theme);
           setConsentConfig(props?.consentConfigData?.theme);
           setLayoutType(props?.consentConfigData?.theme?.layout || "Box");
           setBannerValue(props?.consentConfigData?.theme?.alignment || "leftBottomPopUp");
           setThemeType(props?.consentConfigData?.theme?.type || "Light");
           setButtonStyle(props?.consentConfigData?.theme?.theme?.buttonStyle || "Mixed");
           SetLogoShown(props?.consentConfigData?.isLogoDisplay);
           setBannerContent(props.consentConfigData?.theme?.bannerContent || defaultBannerContent);
           fetchSubscriptions();
        }
       setTempFile([]);
       console.log(tempFile);
       if(!initialRef.current) {
          initialRef.current = true;
          generatePreview(true, regulation, true, bannerContent, activeSection, props?.consentConfigData?.theme.language);
       }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.consentConfigData]);


  useEffect(() => {
    if(props.domainId) {
      const fetchLanguages = async () => {
        try {
          const response = await fetch(config!.regionUrl);
          if (!response.ok) {
            throw new Error('Failed to fetch language options');
          }
          const data = await response.json();
          if (data && data.languages) {
            const formattedOptions = Object.entries(data.languages).map(([value, label]) => ({
              value,
              label
            }));
            setLanguageOptions(formattedOptions);
            const currentLanguage = formattedOptions.find(option => option.value === props.consentConfigData?.theme?.language);
            const englishOption = formattedOptions.find(option => option.value === 'en');
            const defaultLanguage = currentLanguage || englishOption || formattedOptions[0];
            setLanguage(defaultLanguage.value);
            if (consentConfig) {
              consentConfig.language = defaultLanguage.value;
            }
          }
        } catch (error) {
          console.error('Error fetching language options:', error);
        }
      };

      fetchLanguages();
    }
  }, [props.domainId, props.consentConfigData]);

  const fetchSubscriptions = async () => {
    try {
      const response = await pricingService.getSubscriptions(props.domainId);
  
      const activeSubscriptions = Array.isArray(response?.data)
        ? response.data.filter((sub: any) => sub.status === 'active' || sub.status === 'activated')
        : [];
  
      const firstActive = activeSubscriptions.length > 0 ? activeSubscriptions[0] : null;
  
      console.log("Active Subscription:", firstActive);
      setData(firstActive); // ✅ store only the first active subscription object
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      setData(null); // or {} if you prefer
    }
  };
    
  const generatePreview = (isPreview:boolean, regulationType:any, initialPreview:boolean, updatedBannerContent:any, activeSection:string, languageObj:any) => {
      
    if(consentConfig.isLogoDisplay)
        consentConfig.isLogoDisplay = isLogoShown;
      
      if(consentConfig.regulation)
        consentConfig.regulation = regulationType;

      consentConfig.bannerContent = bannerContent;

      if(isPreview) {
        generateHTML(regulationType, initialPreview, updatedBannerContent, activeSection, languageObj);
      }
  };

  const handleLanguage = (languageObj:any) => {
    setLanguage(languageObj);
    setTempFile([]);
    consentConfig.language = languageObj.value; // Use the value property of the language option
    generatePreview(true, regulation, false, bannerContent, activeSection, languageObj);
  };

  const handleContentChange = (field: string, value: string, isNested?: boolean, nestedField?: string) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    timeoutRef.current = setTimeout(() => {
      if (isNested && nestedField) {
        bannerContent[nestedField][field] = value
      } else {
        bannerContent[field] = value;
      }
     
      generatePreview(true, regulation, false, bannerContent, activeSection, language);
    }, 500);
  };
  
  const generateHTML = (regulationType:any, initialPreview:boolean, updatedBannerContent:any, activeSection:string, languageObj:any) => {
      const loadExternalScript = (src:any) => {
        return new Promise<void>((resolve, reject) => {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = src;

          script.onload = () => {
              resolve();
          };

          script.onerror = () => {
              reject(new Error(`Failed to load script ${src}`));
          };

          document.head.appendChild(script);
        });
      }

      const scriptUrl = config?.bannerUrl + '/cookiex.min.js';

      setTimeout(function () {
        loadExternalScript(scriptUrl)
        .then(() => {
            const theme : any = {
                domainId: props.domainId,
                domainUrl: props.domainName,
                selectorId:'coookiex-comp-banner-preview',
                theme: {
                  layout : consentConfig.layout,
                  alignment : consentConfig.alignment || 'leftBottomPopUp',
                  bannerContent: updatedBannerContent,
                  theme : consentConfig?.theme,
                  type  : consentConfig.type,
                  language: languageObj || 'en',
                  regulation : regulationType,
                  isModalOpened: activeSection === 'Preferences',
                  isReConsentOpened: activeSection === 'ReConsent',
                  isInitalConsent: activeSection === 'Initial' || activeSection === ''
                },
                initialPreview: initialPreview
            };

            const cookiex = new Cookiex();
            cookiex.init(theme);
        })
        .catch((error) => {
            console.error('Error loading external script:', error);
        });
      }, 1000);
  };
  
  const handleCustomThemeStyles = (styleType:any) => {
    const filteredTheme = themesConfig.filter(theme => theme.type === styleType);
    if (consentConfig.theme) {
        consentConfig.theme = filteredTheme[0];
    }
    consentConfig.type = styleType;
    setCustomThemeStyle(consentConfig);
    generatePreview(true, regulation, false, bannerContent, activeSection, language);
    setTempFile([]);
  };

  const handleButtonStyles = (styleType: any) => {
    setButtonStyle(styleType); // Update the button style state
  
    // Create a shallow copy of the custom theme style object
    const updatedThemeStyle = { ...customThemeStyle };
  
    // Set button variants based on styleType
    const variant = styleType === "Outline" ? "outline" : "filled";
    updatedThemeStyle.buttonCustomizeVariant = variant;
    updatedThemeStyle.buttonAcceptVariant = variant;
    updatedThemeStyle.buttonRejectVariant = variant;
  
    // Set text color based on the theme type and styleType
    let textColor = "#fff";
    if (customThemeStyle.type === "Light" && styleType === "Outline") {
      textColor = "#0078b4";
    } else if (customThemeStyle.type === "Light" && styleType !== "Outline") {
      textColor = "#fff";
    }
  
    updatedThemeStyle.buttonCustomizeTextColor = textColor;
    updatedThemeStyle.buttonAcceptTextColor = textColor;
    updatedThemeStyle.buttonRejectTextColor = textColor;
  
    // Update the customThemeStyle state
    setCustomThemeStyle(updatedThemeStyle);
  
    // Update the consentConfig object and generate the preview
    const updatedConsentConfig = { ...consentConfig, theme: updatedThemeStyle };
    setConsentConfig(updatedConsentConfig);
    generatePreview(true, regulation, false, bannerContent, activeSection, language);
  };
  
  const handleCustomStyles = (colorValue:any, type:any) => {
    const style = `${type}`;
    customThemeStyle.theme[style] = colorValue;
    setCustomThemeStyle(customThemeStyle);
    generatePreview(true, regulation, false, bannerContent, activeSection, language);
    setTempFile([]);
  };

  const handleCustomButtonStyles = (colorValue:any, buttonType:any, type:any) => {
        const style = `${buttonType}${type}`;
        customThemeStyle.theme[style] = colorValue;
        setCustomThemeStyle(customThemeStyle);
        generatePreview(true, regulation, false, bannerContent, activeSection, language);
        setTempFile([]);
  };

  const handleUpload = (file:any) => {
     setFiles(file);
     setTempFile(file);
     consentService.uploadClientLogo(props.domainId, file);
  };

  const saveConsentBannerConfig = async () => {
    setLoading(true);
    try {
        consentConfig.language = language;
       const res = await props.consentData(consentConfig);
       console.log(res);
    } finally {
        setLoading(false);
    }
  };
  
  const handleBannerContent = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, field: string) => {
    setBannerContent((prev: any) => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  return (
    <React.Fragment>
      <>
      <div style={{ display: 'flex', height: '100%', width: '100%' }}>
        <div style={{ 
          width: '64px',
          flexShrink: 0,
          position: 'relative'
        }}>
          <Sidebar
            expanded={expanded}
            setExpanded={setExpanded}
            hovering={hovering}
            setHovering={setHovering}
          />
      </div>
        <Grid style={{ flex: 1, margin: 0 }}>
              <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
                <Card p="xs">
                  <Tabs defaultValue="gallery" variant="outline">
                  <Group mb={10} gap={5} justify="space-between" style={{ flexGrow: 1, overflowX: 'auto' }}>
                  <Group>
                  <Tabs.List  grow justify="space-between">
                    <Tabs.Tab value="gallery" leftSection={<IconBackground size={12} />}
                    onClick={() => {
                      setActiveSection('Initial');
                      generatePreview(true, regulation, false, bannerContent, 'Initial', language);
                    }}
                    >
                    {t('consentBanner.bannerConfiguration.cookieNotice')}
                    </Tabs.Tab>
                    {data && regulation.value === 'gdpr' && (
                       <>
                        {data.category !== 'ULTIMATE' ? (
                          <Tooltip multiline w={220} position="bottom" label={t('consentBanner.bannerConfiguration.featureNotAvailable')} withArrow>
                              <Tabs.Tab disabled value="messages" leftSection={<IconContainer size={12} />}>
                                  {t('consentBanner.bannerConfiguration.preferenceCentre')}
                              </Tabs.Tab>
                          </Tooltip>
                        ):(
                          <Tabs.Tab value="messages" leftSection={<IconContainer size={12} />}  
                            onClick={() => {
                              setActiveSection('Preferences');
                              generatePreview(true, regulation, false, bannerContent, 'Preferences', language);
                            }}
                          >
                              {t('consentBanner.bannerConfiguration.preferenceCentre')}
                          </Tabs.Tab>
                        )}

                        {data.category !== 'ULTIMATE' ? (
                          <Tooltip multiline w={220} position="bottom" label={t('consentBanner.bannerConfiguration.featureNotAvailable')} withArrow>
                            <Tabs.Tab disabled value="settings" leftSection={<IconSettings size={12} />}>
                              {t('consentBanner.bannerConfiguration.consentManagementModal')}
                            </Tabs.Tab>
                          </Tooltip>  
                        ) : (
                          <Tabs.Tab value="settings" leftSection={<IconSettings size={12} />}
                          onClick={() => {
                            setActiveSection('ReConsent');
                            generatePreview(true, regulation, false, bannerContent, 'ReConsent', language);
                          }}>
                            {t('consentBanner.bannerConfiguration.consentManagementModal')}
                          </Tabs.Tab>
                        )}

                      </>
                    )}
                    {data && regulation.value === 'us' && (
                      <>
                         {data.category !== 'ULTIMATE' ? (
                          <Tooltip multiline w={220} position="bottom" label={t('consentBanner.bannerConfiguration.featureNotAvailable')} withArrow>
                              <Tabs.Tab disabled value="messages" leftSection={<IconContainer size={12} />}>
                                {t('consentBanner.bannerConfiguration.consentPreferenceModal')}
                              </Tabs.Tab>
                          </Tooltip>
                        ):(
                          <Tabs.Tab value="messages" leftSection={<IconContainer size={12} />}  
                            onClick={() => {
                              setActiveSection('Preferences');
                              generatePreview(true, regulation, false, bannerContent, 'Preferences', language);
                            }}
                          >
                              {t('consentBanner.bannerConfiguration.consentPreferenceModal')}
                          </Tabs.Tab>
                        )}
                      </>
                    )}
                  </Tabs.List>
                  </Group>
                  <Button
                      leftSection={loading ? <Loader size="xs" /> : null}
                      variant="filled"
                        size="sm"
                        onClick={saveConsentBannerConfig}
                        disabled={loading} // Prevents multiple clicks
                  >
                        {loading ? t('consentBanner.bannerConfiguration.publishing') : t('consentBanner.bannerConfiguration.publishChanges')}
                  </Button>
                  </Group>

                  <Grid>
                  <Grid.Col span={{ base: 12, md: 3, lg: 3}}>
                    <Tabs.Panel value="gallery">
                      <Tabs p={10} variant="pills" color="#f1f3f5" defaultValue="layout">
                        <Tabs.List>
                          <Tabs.Tab 
                            value="layout" 
                            p={10}
                            style={{ color: '#000', borderRadius: '0px' }}
                          >
                            {t('consentBanner.bannerConfiguration.layout')}
                          </Tabs.Tab>
                          <Tabs.Tab 
                            value="design" 
                            p={10}
                            style={{ color: '#000', borderRadius: '0px' }}
                          >
                            {t('consentBanner.bannerConfiguration.design')}
                          </Tabs.Tab>
                          {data && data.category === 'ULTIMATE' ? (
                            <Tabs.Tab 
                              value="content" 
                              p={10}
                              style={{ color: '#000', borderRadius: '0px' }}
                            >
                              {t('consentBanner.bannerConfiguration.content')}
                            </Tabs.Tab>
                          ) : (
                            <Tooltip 
                              multiline 
                              w={220} 
                              position="bottom" 
                              label={t('consentBanner.bannerConfiguration.featureNotAvailable')} 
                              withArrow
                            >
                              <Tabs.Tab 
                                disabled 
                                value="content" 
                                p={10}
                                style={{ color: '#000', borderRadius: '0px' }}
                              >
                                {t('consentBanner.bannerConfiguration.content')}
                              </Tabs.Tab>
                            </Tooltip>
                        )}
                      </Tabs.List>   

                      <Tabs.Panel value="layout">
                          <Text size="xs" mb="xs" mt="lg" fw={500}>{t('consentBanner.bannerConfiguration.consentTemplate')}</Text>
                          <Flex>                      
                            <Select mr={10}
                              placeholder={t('consentBanner.bannerConfiguration.chooseRegulation')}
                              allowDeselect={false}
                              searchable
                              data={regulations.map((reg) => (
                                  { value: reg.value, label: reg.label }
                              ))}
                              defaultValue={regulation.value}
                              onChange={(value) => {
                                const selectedRegulation = regulations.find((reg) => reg.value === value);
                                setRegulation(selectedRegulation);
                                if (consentConfig) {
                                  consentConfig.regulation = selectedRegulation;
                                }
                                console.log('Selected Regulation:', selectedRegulation);
                                generatePreview(true, selectedRegulation, false, bannerContent, activeSection, language);
                              }}
                            />
                            <Popover width={300} position="right" withArrow shadow="md" opened={openedContent}>
                              <Popover.Target>
                                <IconInfoCircle onMouseEnter={openContent} onMouseLeave={closeContent} />
                              </Popover.Target>
                              <Popover.Dropdown style={{ pointerEvents: 'none' }}>
                                <Text size="sm">{regulation?.description}</Text>
                              </Popover.Dropdown>
                            </Popover>
                          </Flex>
                          <Text size="xs" mt={30} mb="xs" fw={500}>{t('consentBanner.bannerConfiguration.bannerLayout')}{" "}</Text>

                          <Grid>
                            {layouts.map((layout:any, index) => (
                              <Grid.Col key={index} span={{ base: 12, md: 4, lg: 4 }}>
                                <div>
                                  <Paper
                                    shadow="0px"
                                    withBorder
                                    p="lg"
                                    style={{
                                      position: 'relative',
                                      width: '100%',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      minHeight: '80px',
                                      height: '100%',
                                    }}
                                    onClick={() => {
                                      setLayoutType(layout.layoutType);
                                      setBannerValue(layout.bannerValue);
                                      consentConfig.layout = layout.layoutType;
                                      consentConfig.alignment = layout.bannerValue;
                                      generatePreview(true, regulation, false, bannerContent, activeSection, language);
                                    }}
                                  >
                                    <div
                                      className="fill-primary"
                                      style={layout.styles}
                                    ></div>
                                    {layoutType === layout.layoutType && (
                                      <IconCircleCheckFilled
                                        className="primary"
                                        size="1rem"
                                        stroke={3}
                                        style={{ left: "-8px", top: "-7px", position: "absolute" }}
                                      />
                                    )}
                                  </Paper>
                                  <Text size="xs" mt={5} ta="center">
                                    {layout.text === 'Box' && t('consentBanner.bannerConfiguration.box')}
                                    {layout.text === 'Banner' && t('consentBanner.bannerConfiguration.banner')}
                                    {layout.text === 'Popup' && t('consentBanner.bannerConfiguration.popup')}
                                  </Text>
                                </div>
                              </Grid.Col>
                            ))}
                          </Grid>
                          {(layoutType === "Box" || layoutType === "Banner") && (
                            <>
                              <Text size="xs" mt={30} mb="xs" fw={500}>{t('consentBanner.bannerConfiguration.alignment')}{" "}</Text>
                              <Radio.Group mt={15} mb={15} value={bannerValue}
                                onChange={(e : any) => {
                                  setBannerValue(e);
                                  consentConfig.alignment = e;
                                  generatePreview(true, regulation, false, bannerContent, activeSection, language);
                                }}>
                                <SimpleGrid cols={2}>
                                 
                                  {layoutType === "Box" && (
                                    <>
                                      <Radio size="xs" value="leftBottomPopUp" label={t('consentBanner.bannerConfiguration.bottomLeft')} />
                                      <Radio size="xs" value="rightBottomPopUp" label={t('consentBanner.bannerConfiguration.bottomRight')} />
                                      <Radio size="xs" value="leftTopPopUp" label={t('consentBanner.bannerConfiguration.topLeft')} />
                                      <Radio size="xs" value="rightTopPopUp" label={t('consentBanner.bannerConfiguration.topRight')} />
                                    </>
                                  )}
                                  {layoutType === "Banner" && (
                                    <>
                                      <Radio size="xs" value="bannerTop" label={t('consentBanner.bannerConfiguration.top')} />
                                      <Radio size="xs" value="bannerBottom" label={t('consentBanner.bannerConfiguration.bottom')} />
                                    </>
                                  )}
                                </SimpleGrid>
                              </Radio.Group>
                            </>
                          )}
                          {languageOptions.length > 0 && (
                              <>
                                <Text size="xs" mt={30} mb="xs" fw={500}>{t('consentBanner.bannerConfiguration.language')}{" "}</Text>
                                <Select allowDeselect={false} defaultValue={language} data={languageOptions} onChange={(event) => handleLanguage(event)} />
                              </>
                          )}
                      </Tabs.Panel>

                      <Tabs.Panel value="design">
                      <Select 
                          label={t('consentBanner.bannerConfiguration.theme')} 
                          mt="lg" 
                          allowDeselect={false} 
                          defaultValue={props.consentConfigData?.theme?.type} 
                          onChange={(event) => handleCustomThemeStyles(event)} 
                          data={[
                            { value: "Light", label: t('consentBanner.bannerConfiguration.light') },
                            { value: "Dark", label: t('consentBanner.bannerConfiguration.dark') },
                            { value: "Custom", label: t('consentBanner.bannerConfiguration.custom') }
                          ]}
                        />

                          <div>
                              {customThemeStyle?.type == 'Custom' && (
                                <div>
                                    <BannerTheme customStyles={handleCustomStyles} background={customThemeStyle?.theme?.background || "#fff"} name="background" label={t('consentBanner.bannerConfiguration.background')} description="" />
                                    <BannerTheme customStyles={handleCustomStyles} background={customThemeStyle?.theme?.textColor || "#000"} name="textColor" label={t('consentBanner.bannerConfiguration.textColor')} description={t('consentBanner.bannerConfiguration.textColorDesc')} />
                                    <BannerTheme customStyles={handleCustomStyles} background={customThemeStyle?.theme?.highlight || "#fff"} name="highlight" label={t('consentBanner.bannerConfiguration.highlight')} description={t('consentBanner.bannerConfiguration.highlightDesc')} />
                                    <Divider my="sm" />
                                    {regulation.value === 'gdpr' && (
                                      <>
                                      <Group justify="left"><Text size="xs">{t('consentBanner.bannerConfiguration.button1')}</Text></Group>
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonRejectBackGround || "#fff"} label={t('consentBanner.bannerConfiguration.background')} type="buttonReject" description="" />
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonRejectTextColor || "#000"} label={t('consentBanner.bannerConfiguration.textColor')} type="buttonReject" description="" />
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonRejectBorder || "#fff"} label={t('consentBanner.bannerConfiguration.border')} type="buttonReject" description="" />
                                      <Divider my="sm" />
                                      <Group justify="left"><Text size="xs">{t('consentBanner.bannerConfiguration.button2')}</Text></Group>
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonAcceptBackGround || "#fff"} label={t('consentBanner.bannerConfiguration.background')} type="buttonAccept" description="" />
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonAcceptTextColor || "#000"} label={t('consentBanner.bannerConfiguration.textColor')} type="buttonAccept" description="" />
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonAcceptBorder || "#fff"} label={t('consentBanner.bannerConfiguration.border')} type="buttonAccept" description="" />
                                      <Divider my="sm" />
                                      <Group justify="left"><Text size="xs">{t('consentBanner.bannerConfiguration.button3')}</Text></Group>
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonCustomizeBackGround || "#fff"} label={t('consentBanner.bannerConfiguration.background')} type="buttonCustomize" description="" />
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonCustomizeTextColor || "#000"} label={t('consentBanner.bannerConfiguration.textColor')} type="buttonCustomize" description="" />
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonCustomizeBorder || "#fff"} label={t('consentBanner.bannerConfiguration.border')} type="buttonCustomize" description="" />
                                    </>
                                  )}
                                  {regulation.value === 'us' && (
                                    <>
                                      <Group justify="left" mt={20}><Text size="xs">{t('consentBanner.bannerConfiguration.button4')}</Text></Group>
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonRejectBackGround || "#fff"} label={t('consentBanner.bannerConfiguration.background')} type="buttonReject" description="" />
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonRejectTextColor || "#000"} label={t('consentBanner.bannerConfiguration.textColor')} type="buttonReject" description="" />
                                      <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.buttonRejectBorder || "#fff"} label={t('consentBanner.bannerConfiguration.border')} type="buttonReject" description="" />
                                    </>
                                  )}
                                </div>
                              )}
                              {customThemeStyle?.type != 'Custom' && (
                                <Select 
                                mt={10} 
                                allowDeselect={false} 
                                label={t('consentBanner.bannerConfiguration.buttonStyle')} 
                                defaultValue={buttonStyle} 
                                onChange={(event) => handleButtonStyles(event)}  
                                data={[
                                  { value: "Outline", label: t('consentBanner.bannerConfiguration.outline') },
                                  { value: "Mixed", label: t('consentBanner.bannerConfiguration.mixed') },
                                  { value: "Solid", label: t('consentBanner.bannerConfiguration.solid') }
                                ]}
                              />                              
                              )}
                          </div>
                          {data && data.category == 'ULTIMATE' && (
                            <>
                              <Group justify="left" mt={10}>
                                  <Title order={6} fw={500}>{t('consentBanner.bannerConfiguration.logo')}</Title>
                                  <Tooltip label={t('consentBanner.bannerConfiguration.logoTooltip')}>
                                    <IconInfoCircle size="14"/>
                                  </Tooltip>
                              </Group>
                              <Checkbox mt={4}
                                mb={10}
                                checked={isLogoShown}
                                onChange={(event) => SetLogoShown(event.currentTarget.checked)}
                                label={t('consentBanner.bannerConfiguration.displayLogo')}
                              />
                              <Dropzone
                                maxFiles={1}
                                accept={[MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.svg, MIME_TYPES.gif]}
                                onDrop={handleUpload}
                              >
                                <Group justify="center">
                                  <IconUpload size={15} color="blue" />
                                  <Text size="xs" ta="center" c="blue">
                                    {t('consentBanner.bannerConfiguration.uploadFile')}
                                  </Text>
                                </Group>
                              </Dropzone>
                              <Text size="xs" mt={10}>
                                {t('consentBanner.bannerConfiguration.fileTypes')}
                              </Text>
                            </>
                          )}
                        
                      </Tabs.Panel>

                      <Tabs.Panel value="content">
                        <>
                        <ScrollArea h={500} scrollHideDelay={6000}>
                            <TextInput
                              label={t('consentBanner.bannerConfiguration.bannerTitle')}
                              placeholder="Banner Title"
                              defaultValue={bannerContent.title}
                              onChange={(e) => handleContentChange("title", e.target.value, false, "")}
                            />
                            <Text size="sm" mt={10} mb="xs" fw={600}>{t('consentBanner.bannerConfiguration.bannerDescription')}{" "}</Text>
                            <ReactQuill theme="snow" value={bannerContent.description} onChange={(value) => handleContentChange("description", value, false, "")} />
                            {data && data.category == 'ULTIMATE' && regulation.value === 'gdpr' && (
                              <>
                                <TextInput
                                  label={t('consentBanner.bannerConfiguration.acceptButton')}
                                  placeholder={`"Accept All" Button`}
                                  defaultValue={bannerContent.Accept}
                                  onChange={(e) => handleContentChange("Accept", e.target.value, false, "")}
                                />
                                <TextInput
                                  label={t('consentBanner.bannerConfiguration.rejectButton')}
                                  placeholder={`"Reject All" Button`}
                                  defaultValue={bannerContent.Reject}
                                  onChange={(e) => handleContentChange("Reject", e.target.value, false, "")}
                                />
                                <TextInput
                                  label={t('consentBanner.bannerConfiguration.customizeButton')}
                                  placeholder={`"Customize" Button`}
                                  defaultValue={bannerContent.Customize}
                                  onChange={(e) => handleContentChange("Customize", e.target.value, false, "")}
                                />
                                <TextInput mt={10}
                                  label={t('consentBanner.bannerConfiguration.cookiePolicyUrl')}
                                  placeholder={t('consentBanner.bannerConfiguration.cookiePolicyUrl')}
                                  defaultValue={bannerContent.policyUrl}
                                  onChange={(e) => handleContentChange("policyUrl", e.target.value, false, "")}
                                />
                                <TextInput mt={10}
                                  label={t('consentBanner.bannerConfiguration.privacyPolicyUrl')}
                                  placeholder={t('consentBanner.bannerConfiguration.privacyPolicyUrl')}
                                  defaultValue={bannerContent.privacyPolicyUrl}
                                  onChange={(e) => handleContentChange("privacyPolicyUrl", e.target.value, false, "")}
                                />
                              </>
                            )}
                            {data && data.category == 'ULTIMATE' && regulation.value === 'us' && (
                                <TextInput mt={10}
                                  label={t('consentBanner.bannerConfiguration.doNotSellButton')}
                                  placeholder={t('consentBanner.bannerConfiguration.doNotSellButton')}
                                  defaultValue={bannerContent.NotSellData}
                                  onChange={(e) => handleContentChange("NotSellData", e.target.value, false, "")}
                              />
                            )}
                            </ScrollArea>
                        </>
                      </Tabs.Panel>
                    </Tabs>
                  </Tabs.Panel>

                  <Tabs.Panel value="messages">
                    <Tabs p={10} color="#f1f3f5" variant="pills" defaultValue="design">
                      <Tabs.List>
                        <Tabs.Tab value="design" style={{ color: '#000', borderRadius: '0px' }}>
                          {t('consentBanner.bannerConfiguration.design')}
                        </Tabs.Tab>
                        {data && data.category == 'ULTIMATE' ? (
                          <Tabs.Tab value="content" p={10} style={{ color: '#000', borderRadius: '0px' }}>
                            {t('consentBanner.bannerConfiguration.content')}
                          </Tabs.Tab>
                        ) : (
                          <Tooltip multiline w={220} position="bottom" label={t('consentBanner.bannerConfiguration.ultimatePlanRequired')} withArrow>
                            <div style={{ pointerEvents: 'none' }}>
                              <Tabs.Tab value="content" disabled style={{ color: '#000', borderRadius: '0px' }}>
                                {t('consentBanner.bannerConfiguration.content')}
                              </Tabs.Tab>
                            </div>
                          </Tooltip>
                        )}
                      </Tabs.List>

                      <Divider mt={20} />

                      <Tabs.Panel value="design">
                        <div>
                          <div>
                            <BannerTheme customStyles={handleCustomStyles} background={customThemeStyle?.theme?.bannerPrefBg || "#fff"} name="bannerPrefBg" label={t('consentBanner.bannerConfiguration.background')} description="" />
                            <BannerTheme customStyles={handleCustomStyles} background={customThemeStyle?.theme?.bannerPrefTxtClr || "#000"} name="bannerPrefTxtClr" label={t('consentBanner.bannerConfiguration.textColor')} description={t('consentBanner.bannerConfiguration.textColorDescription')} />
                            <Divider my="sm" />
                            <Group justify="left"><Text size="xs"> {t('consentBanner.bannerConfiguration.button1')} ({regulation.value === 'gdpr' ? t('consentBanner.bannerConfiguration.rejectAll') : t('consentBanner.bannerConfiguration.savePreferences')}) </Text></Group>
                            <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.bannerPrefBtnRejBackGround || "#fff"} label={t('consentBanner.bannerConfiguration.background')} type="bannerPrefBtnRej" description="" />
                            <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.bannerPrefBtnRejTextColor || "#000"} label={t('consentBanner.bannerConfiguration.textColor')} type="bannerPrefBtnRej" description="" />
                            <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.bannerPrefBtnRejBorder || "#fff"} label={t('consentBanner.bannerConfiguration.border')} type="bannerPrefBtnRej" description="" />
                            <Divider my="sm" />
                            <Group justify="left"><Text size="xs"> {t('consentBanner.bannerConfiguration.button2')} ({regulation.value === 'gdpr' ? t('consentBanner.bannerConfiguration.allowSelection') : t('consentBanner.bannerConfiguration.cancel')}) </Text></Group>
                            <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.bannerPrefBtnAccBackGround || "#000"} label={t('consentBanner.bannerConfiguration.background')} type="bannerPrefBtnAcc" description="" />
                            <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.bannerPrefBtnAccTextColor || "#fff"} label={t('consentBanner.bannerConfiguration.textColor')} type="bannerPrefBtnAcc" description="" />
                            <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.bannerPrefBtnAccBorder || "#000"} label={t('consentBanner.bannerConfiguration.border')} type="bannerPrefBtnAcc" description="" />
                            <Divider my="sm" />
                            <Group justify="left"><Text size="xs"> {t('consentBanner.bannerConfiguration.button3')} ({t('consentBanner.bannerConfiguration.acceptAll')}) </Text></Group>
                            <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.bannerPrefBtnAccAllBackGround || "#000"} label={t('consentBanner.bannerConfiguration.background')} type="bannerPrefBtnAccAll" description="" />
                            <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.bannerPrefBtnAccAllTextColor || "#fff"} label={t('consentBanner.bannerConfiguration.textColor')} type="bannerPrefBtnAccAll" description="" />
                            <ButtonTheme customStyles={handleCustomButtonStyles} background={customThemeStyle?.theme?.bannerPrefBtnAccAllBorder || "#000"} label={t('consentBanner.bannerConfiguration.border')} type="bannerPrefBtnAccAll" description="" />
                          </div>
                        </div>
                      </Tabs.Panel>

                      <Tabs.Panel value="content">
                        <>
                        <ScrollArea h={500} scrollHideDelay={6000}>
                          <TextInput mb={10} mt={20}
                            label={t('consentBanner.bannerConfiguration.modalTitle')}
                            placeholder={t('consentBanner.bannerConfiguration.modalTitle')}
                            defaultValue={bannerContent.modalTitle}
                            onChange={(e) => handleContentChange("modalTitle", e.target.value, false, "")}
                          />
                          <Text size="sm" mt={10} mb="xs" fw={600}>{t('consentBanner.bannerConfiguration.modalDescription')}{" "}</Text>
                          <ReactQuill theme="snow" value={bannerContent.modalDescription} onChange={(value) => handleContentChange("modalDescription", value, false, "")} />
                          {regulation.value === 'us' && (
                            <>
                              <Text size="sm" mt={10} mb="xs" fw={600}>{t('consentBanner.bannerConfiguration.description')}{" "}</Text>
                              <ReactQuill theme="snow" value={bannerContent.modalSubDescription} onChange={(value) => handleContentChange("modalSubDescription", value, true, "")} />
                              <TextInput mb={10} mt={20}
                                label={t('consentBanner.bannerConfiguration.doNotSellMyInfo')}
                                placeholder={t('consentBanner.bannerConfiguration.doNotSellMyInfo')}
                                defaultValue={bannerContent.NotSellData}
                                onChange={(e) => handleContentChange("NotSellData", e.target.value, false, "")}
                              />
                            </>
                          )}
                          {regulation.value === 'gdpr' && (
                            <>
                              <TextInput mb={10}
                                label={t('consentBanner.bannerConfiguration.necessaryCookies')}
                                placeholder={t('consentBanner.bannerConfiguration.necessaryCookies')}
                                defaultValue={bannerContent.options.Necessary}
                                onChange={(e) => handleContentChange("Necessary", e.target.value, true, "options")}
                              />
                              <TextInput mb={10}
                                label={t('consentBanner.bannerConfiguration.preferencesCookies')}
                                placeholder={t('consentBanner.bannerConfiguration.preferencesCookies')}
                                defaultValue={bannerContent.options.Preferences}
                                onChange={(e) => handleContentChange("Preferences", e.target.value, true, "options")}
                              />
                              <TextInput mb={10}
                                label={t('consentBanner.bannerConfiguration.statisticsCookies')}
                                placeholder={t('consentBanner.bannerConfiguration.statisticsCookies')}
                                defaultValue={bannerContent.options.Statistics}
                                onChange={(e) => handleContentChange("Statistics", e.target.value, true, "options")}
                              />
                              <TextInput mb={10}
                                label={t('consentBanner.bannerConfiguration.marketingCookies')}
                                placeholder={t('consentBanner.bannerConfiguration.marketingCookies')}
                                defaultValue={bannerContent.options.Marketing}
                                onChange={(e) => handleContentChange("Marketing", e.target.value, true, "options")}
                              />
                              <TextInput mb={10}
                                label={t('consentBanner.bannerConfiguration.unclassifiedCookies')}
                                placeholder={t('consentBanner.bannerConfiguration.unclassifiedCookies')}
                                defaultValue={bannerContent.options.Unclassified}
                                onChange={(e) => handleContentChange("Unclassified", e.target.value, true, "options")}
                              />
                              <Text size="sm" mt={10} mb="xs" fw={600}>{t('consentBanner.bannerConfiguration.necessaryDescription')}{" "}</Text>
                              <ReactQuill theme="snow" value={bannerContent.descriptions.Necessary} onChange={(value) => handleContentChange("Necessary", value, true, "descriptions")} />
                              <Text size="sm" mt={10} mb="xs" fw={600}>{t('consentBanner.bannerConfiguration.preferencesDescription')}{" "}</Text>
                              <ReactQuill theme="snow" value={bannerContent.descriptions.Preferences} onChange={(value) => handleContentChange("Preferences", value, true, "descriptions")} />
                              <Text size="sm" mt={10} mb="xs" fw={600}>{t('consentBanner.bannerConfiguration.statisticsDescription')}{" "}</Text>
                              <ReactQuill theme="snow" value={bannerContent.descriptions.Statistics} onChange={(value) => handleContentChange("Statistics", value, true, "descriptions")} />
                              <Text size="sm" mt={10} mb="xs" fw={600}>{t('consentBanner.bannerConfiguration.marketingDescription')}{" "}</Text>
                              <ReactQuill theme="snow" value={bannerContent.descriptions.Marketing} onChange={(value) => handleContentChange("Marketing", value, true, "descriptions")} />
                              <Text size="sm" mt={10} mb="xs" fw={600}>{t('consentBanner.bannerConfiguration.unclassifiedDescription')}{" "}</Text>
                              <ReactQuill theme="snow" value={bannerContent.descriptions.Unclassified} onChange={(value) => handleContentChange("Unclassified", value, true, "descriptions")} />
                              <TextInput mb={10}
                                label={t('consentBanner.bannerConfiguration.rejectAllButton')}
                                placeholder={t('consentBanner.bannerConfiguration.rejectAllButton')}
                                defaultValue={bannerContent.Reject}
                                onChange={(e) => handleContentChange("Reject", e.target.value, false, "")}
                              />
                              <TextInput mb={10}
                                label={t('consentBanner.bannerConfiguration.allowSelectionButton')}
                                placeholder={t('consentBanner.bannerConfiguration.allowSelectionButton')}
                                defaultValue={bannerContent.AllowSelection}
                                onChange={(e) => handleContentChange("AllowSelection", e.target.value, false, "")}
                              />
                              <TextInput mb={10} mt={10}
                                label={t('consentBanner.bannerConfiguration.acceptAllButton')}
                                placeholder={t('consentBanner.bannerConfiguration.acceptAllButton')}
                                defaultValue={bannerContent.Accept}
                                onChange={(e) => handleContentChange("Accept", e.target.value, false, "")}
                              />
                            </>
                          )}
                          {regulation.value === 'us' && (
                            <>
                              <TextInput mb={10}
                                label={t('consentBanner.bannerConfiguration.savePreferencesButton')}
                                placeholder={t('consentBanner.bannerConfiguration.savePreferencesButton')}
                                defaultValue={bannerContent.savePreferences}
                                onChange={(e) => handleContentChange("savePreferences", e.target.value, false, "")}
                              />
                              <TextInput mb={10} mt={10}
                                label={t('consentBanner.bannerConfiguration.cancelButton')}
                                placeholder={t('consentBanner.bannerConfiguration.cancelButton')}
                                defaultValue={bannerContent.Cancel}
                                onChange={(e) => handleContentChange("Cancel", e.target.value, false, "")}
                              />
                            </>
                          )}
                        </ScrollArea>
                      </>
                      </Tabs.Panel>
                    </Tabs>

                  </Tabs.Panel>

                  <Tabs.Panel value="settings">
                  <Tabs p={10}  color="#f1f3f5" variant="pills" defaultValue="design">
            <Tabs.List>
              <Tabs.Tab value="design" style={{ color: '#000', borderRadius: '0px' }}>
                 {t('consentBanner.bannerConfiguration.design')}
              </Tabs.Tab>
              {data && data.category == 'ULTIMATE' && (
                <Tabs.Tab value="content" style={{ color: '#000', borderRadius: '0px' }}>
                {t('consentBanner.bannerConfiguration.content')}
                </Tabs.Tab>
              )}
            </Tabs.List>

            <Divider mt={20} />      

            <Tabs.Panel value="design">
                  <div>
                    <div>
                        <BannerTheme customStyles={handleCustomStyles} background={customThemeStyle?.theme?.bannerReconsentBg || "#fff"} name="bannerReconsentBg" label={t('consentBanner.bannerConfiguration.background')} description="" />
                        <BannerTheme customStyles={handleCustomStyles} background={customThemeStyle?.theme?.bannerReconsentTextColor || "#000"} name="bannerReconsentTextColor" label={t('consentBanner.bannerConfiguration.textColor')} description={t('consentBanner.bannerConfiguration.chooseColor')} />
                <Divider my="sm" />
                <Group justify="left">
                  <Text size="xs">
                    {t('consentBanner.bannerConfiguration.button1')} ({t('consentBanner.bannerConfiguration.withdrawConsent')})
                  </Text>
                </Group>
                <ButtonTheme 
                  customStyles={handleCustomButtonStyles} 
                  background={customThemeStyle?.theme?.bannerReconsntBtnWithDrawBackGround || "#fff"} 
                  label={t('consentBanner.bannerConfiguration.background')} 
                  type="bannerReconsntBtnWithDraw" 
                  description="" 
                />
                <ButtonTheme 
                  customStyles={handleCustomButtonStyles} 
                  background={customThemeStyle?.theme?.bannerReconsntBtnWithDrawTextColor || "#000"} 
                  label={t('consentBanner.bannerConfiguration.textColor')} 
                  type="bannerReconsntBtnWithDraw" 
                  description="" 
                />
                <ButtonTheme 
                  customStyles={handleCustomButtonStyles} 
                  background={customThemeStyle?.theme?.bannerReconsntBtnWithDrawBorder || "#fff"} 
                  label={t('consentBanner.bannerConfiguration.border')} 
                  type="bannerReconsntBtnWithDraw" 
                  description="" 
                />
                <Divider my="sm" />
                <Group justify="left">
                  <Text size="xs">
                    {t('consentBanner.bannerConfiguration.button2')} ({t('consentBanner.bannerConfiguration.updateConsent')})
                  </Text>
                </Group>
                <ButtonTheme 
                  customStyles={handleCustomButtonStyles} 
                  background={customThemeStyle?.theme?.bannerReconsntBtnUpdtCnsntBackGround || "#fff"} 
                  label={t('consentBanner.bannerConfiguration.background')} 
                  type="bannerReconsntBtnUpdtCnsnt" 
                  description="" 
                />
                <ButtonTheme 
                  customStyles={handleCustomButtonStyles} 
                  background={customThemeStyle?.theme?.bannerReconsntBtnUpdtCnsntTextColor || "#000"} 
                  label={t('consentBanner.bannerConfiguration.textColor')} 
                  type="bannerReconsntBtnUpdtCnsnt" 
                  description="" 
                />
                <ButtonTheme 
                  customStyles={handleCustomButtonStyles} 
                  background={customThemeStyle?.theme?.bannerReconsntBtnUpdtCnsntBorder || "#fff"} 
                  label={t('consentBanner.bannerConfiguration.border')} 
                  type="bannerReconsntBtnUpdtCnsnt" 
                  description="" 
                />
              </div>
            </div>
          </Tabs.Panel>

          <Tabs.Panel value="content">
              <>
            <ScrollArea h={500} scrollHideDelay={6000}>
              <TextInput 
                mb={10} 
                mt={20}
                label={t('consentBanner.bannerConfiguration.title')}
                placeholder={t('consentBanner.bannerConfiguration.title')}
                defaultValue={bannerContent.CookieConsent}
                onChange={(e) => handleContentChange("CookieConsent", e.target.value, false, "")}
              />
              <TextInput mb={10} mt={20}
                label={t('consentBanner.bannerConfiguration.consentID')}
                placeholder={t('consentBanner.bannerConfiguration.consentID')}
                defaultValue={bannerContent.ConsentID}
                onChange={(e) => handleContentChange("ConsentID", e.target.value, false, "")}
              />
              <TextInput mb={10} mt={20}
                label={t('consentBanner.bannerConfiguration.timestamp')}
                placeholder={t('consentBanner.bannerConfiguration.timestamp')}
                defaultValue={bannerContent.Timestamp}
                onChange={(e) => handleContentChange("Timestamp", e.target.value, false, "")}
              />
              <div>
                <Text size="sm" mt={10} mb="xs" fw={600}>{t('consentBanner.bannerConfiguration.consentGiven')}</Text>
                <ReactQuill theme="snow" value={bannerContent.ConsentGiven} onChange={(value) => handleContentChange("ConsentGiven", value, false, "")} />
              </div>
              <TextInput mb={10}
                label={t('consentBanner.bannerConfiguration.necessaryCookies')}
                placeholder={t('consentBanner.bannerConfiguration.necessaryCookies')}
                defaultValue={bannerContent.options.Necessary}
                onChange={(e) => handleContentChange("Necessary", e.target.value, true, "options")}
              />
              <TextInput mb={10}
                label={t('consentBanner.bannerConfiguration.preferencesCookies')}
                placeholder={t('consentBanner.bannerConfiguration.preferencesCookies')}
                defaultValue={bannerContent.options.Preferences}
                onChange={(e) => handleContentChange("Preferences", e.target.value, true, "options")}
              />
              <TextInput mb={10}
                label={t('consentBanner.bannerConfiguration.statisticsCookies')}
                placeholder={t('consentBanner.bannerConfiguration.statisticsCookies')}
                defaultValue={bannerContent.options.Statistics}
                onChange={(e) => handleContentChange("Statistics", e.target.value, true, "options")}
              />
              <TextInput mb={10}
                label={t('consentBanner.bannerConfiguration.marketingCookies')}
                placeholder={t('consentBanner.bannerConfiguration.marketingCookies')}
                defaultValue={bannerContent.options.Marketing}
                onChange={(e) => handleContentChange("Marketing", e.target.value, true, "options")}
              />
              <TextInput mb={10}
                label={t('consentBanner.bannerConfiguration.unclassifiedCookies')}
                placeholder={t('consentBanner.bannerConfiguration.unclassifiedCookies')}
                defaultValue={bannerContent.options.Unclassified}
                onChange={(e) => handleContentChange("Unclassified", e.target.value, true, "options")}
              />
              <TextInput 
                mb={10}
                label={t('consentBanner.bannerConfiguration.withdrawConsentButton')}
                placeholder={t('consentBanner.bannerConfiguration.withdrawConsentButton')}
                defaultValue={bannerContent.WithdrawConsent}
                onChange={(e) => handleContentChange("WithdrawConsent", e.target.value, false, "")}
              />
              <TextInput 
                mb={10}
                label={t('consentBanner.bannerConfiguration.updateConsentButton')}
                placeholder={t('consentBanner.bannerConfiguration.updateConsentButton')}
                defaultValue={bannerContent.UpdateConsent}
                onChange={(e) => handleContentChange("UpdateConsent", e.target.value, false, "")}
              />
            </ScrollArea>
              </>
          </Tabs.Panel>
        </Tabs>

      </Tabs.Panel>
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 9, lg: 9 }}>
                      <div className="cookiex-preview-wrapper">
                          <div className="cookiex-preview-box">
                            {props?.domainName?.startsWith("http") ? (
                              <iframe
                                src={props.domainName + '?hideHeader=true'}
                                title="Website Preview"
                                scrolling="no"
                                style={{ 
                                  width: "100%", 
                                  height: "100%", 
                                  border: "none", 
                                  pointerEvents: "none"
                                }}
                              />
                            ) : (
                              <img
                                src={colorgradient}
                                alt="Preview Background"
                              />
                            )}
                          </div>
                          <div id="coookiex-comp-banner-preview" />
                        </div>
                      </Grid.Col>
                    </Grid>
    </Tabs>
  </Card>
</Grid.Col>
</Grid>
</div>
      </>
    </React.Fragment>
  );
}

export { BannerConfiguration };
